import { BaseCategory } from "./BaseCategory";
import { AssetType, HeaderPositionType, PaletteColorType } from "../constants";
import { SlideCategories } from "./CategoryController";
import { SlideModelBuilder } from "./SlideModelBuilder";
import { v4 as uuid } from "uuid";

export class LogoGridCategory extends BaseCategory {
    get name() {
        return "Logo Grid";
    }

    get type() {
        return SlideCategories.LOGO_GRID;
    }

    get icon() {
        return null;
    }

    get description() {
        return "Use for displaying a collection of company logos, partner logos, client logos, or brand marks in a grid layout. Ideal for showcasing partnerships, clients, sponsors, or portfolio brands.";
    }

    get slideTypes() {
        return [];
    }

    getPrompt() {
        return `Create a logo grid slide based on the user's prompt.
        Provide search terms for each logo to be displayed.
        Support between 1 and 12 logos.`;
    }

    getPromptSchema() {
        return {
            logos: [{
                searchTerm: "search term for the logo (e.g., 'Apple logo', 'Microsoft logo', 'company name logo')",
                name: "optional name of the company/brand"
            }],
            conclusion: "an optional short conclusion or takeaway for the slide",
        };
    }

    getImagePrompt() {
        return false;
    }

    getSlideModels(model) {
        let models = [
            this.buildLogoGrid(model)
        ];
        return models;
    }

    buildLogoGrid(model) {
        let builder = new SlideModelBuilder("logogrid", model);

        // Add header if there's a title
        if (model.slideTitle) {
            builder.createHeader({
                heading: model.slideTitle,
                position: HeaderPositionType.TOP
            });
        }

        builder.setBackgroundColor(PaletteColorType.BACKGROUND_ACCENT);

        // Limit to 12 logos
        let logos = model.logos.slice(0, 12);

        // Create the primary logo grid element with showFrame always on
        builder.createPrimary({
            items: logos.map((logo, index) => ({
                backgroundColor: "white",
                ...builder.createLogo(logo.searchTerm)
            })),
            showFrame: true
        });

        if (model.conclusion) {
            builder.createBottomTray(model.conclusion);
        }

        return builder.model;
    }
}
